import React, { useState } from "react";
import { Table, Form, Button } from "react-bootstrap";
import { CustomModal } from "../../components";
import { toast } from "react-toastify";
import {
  useFetchAllAdminmessagesQuery,
  useSendMessageMutation,
  useFetchProfilesQuery,
} from "../../store/api/apiSlice";

const MessagesManagment = () => {
  const [sendMessage] = useSendMessageMutation();
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const { data: profileData, error } = useFetchProfilesQuery();
  const {
    data: messageData = { messages: [] },
    isLoading,
    refetch,
  } = useFetchAllAdminmessagesQuery();
  const messages = messageData.messages;
  const paginatedUsers = messages.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(messages.length / itemsPerPage);

  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [messageText, setMessageText] = useState("");
  const openViewModal = (msg) => {
    setSelectedMessage(msg);
    setViewModalOpen(true);
  };
  const closeViewModal = () => {
    setSelectedMessage(null);
    setViewModalOpen(false);
  };
  const handlesSubmit = async (e) => {
    e.preventDefault();

    try {
      const newMessage = {
        userId: profileData?.user?._id,
        forumId: "0",
        receiverId: selectedMessage?.userId,
        message: messageText,
        messageType: "text",
        type: "private",
        messageNote: "",
        status: true,
      };
      const response = await sendMessage(newMessage).unwrap();
      if (response.message === "Message Created Successfully") {
        setMessageText("");
        setViewModalOpen(false);
        toast.success("Message sent Successfully!");
      }
    } catch (error) {
      toast.error("Failed to send message.");
    }
  };
  return (
    <div className="container">
      <h3 className="mb-4" style={{ marginTop: "22px" }}>
        Messages
      </h3>
      <div style={{ display: "flex", justifyContent: "flex-end" }}></div>

      <Table striped bordered hover responsive className="advertisers-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Message Date</th>
          </tr>
        </thead>
        <tbody>
          {paginatedUsers.map((msg) => (
            <tr
              key={msg._id}
              onClick={() => openViewModal(msg)}
              style={{ cursor: "pointer" }}
            >
              <td>{`${msg.userFirstName} ${msg.userLastName}`}</td>
              <td>{msg.userEmail}</td>
              <td>{msg.userPhone}</td>
              <td>{new Date(msg.createdAt).toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="d-flex justify-content-center mt-3">
        {Array.from({ length: totalPages }, (_, index) => (
          <Button
            key={index}
            variant={currentPage === index + 1 ? "primary" : "outline-primary"}
            onClick={() => setCurrentPage(index + 1)}
            className="mx-1"
          >
            {index + 1}
          </Button>
        ))}
      </div>
      {isViewModalOpen && selectedMessage && (
        <CustomModal isOpen={isViewModalOpen} onClose={closeViewModal}>
          <div
            style={{
              maxHeight: "80vh",
              fontFamily: "Arial, sans-serif",
              color: "#333",
              textAlign: "center",
            }}
          >
            <h3
              style={{
                fontWeight: "bold",
                fontSize: "1.6rem",
                color: "#333",
                marginBottom: "20px",
                borderBottom: "2px solid #eee",
                paddingBottom: "10px",
              }}
            >
              Messages Details
            </h3>

            <div style={{ textAlign: "left", marginBottom: "15px" }}>
              <p>
                <strong>Name:</strong>{" "}
                {`${selectedMessage.userFirstName} ${selectedMessage.userLastName}`}
              </p>
              <p>
                <strong>Email:</strong> {selectedMessage.userEmail}
              </p>
              <p>
                <strong>Phone:</strong> {selectedMessage.userPhone}
              </p>
              <p>
                <strong>School:</strong> {selectedMessage.userSchool}
              </p>
              <p>
                <strong>Message:</strong> {selectedMessage.message}
              </p>
              <p>
                <strong>Message Date:</strong>{" "}
                {new Date(selectedMessage.createdAt).toLocaleString()}
              </p>
            </div>

            <Form onSubmit={handlesSubmit}>
              <Form.Group controlId="message">
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={messageText}
                  onChange={(e) => setMessageText(e.target.value)}
                  placeholder="Type your message here..."
                  required
                />
              </Form.Group>
              <div className="pt-3">
                <Button variant="primary" type="submit">
                  Reply
                </Button>
              </div>
            </Form>
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default MessagesManagment;
